// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3X6ui","fadeIn":"Login_fadeIn__2B5w0","btn":"Login_btn__3F7za"};